export const primaryButtonStyles = {
  backgroundColor: '#000',
  borderRadius: '9999px',
  boxShadow: 'none',
  color: '#fff',
  fontSize: '14px',
  fontWeight: 600,
  padding: '8px 16px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#1a1a1a',
    boxShadow: 'none',
  },
};

export const secondaryButtonStyles = {
  backgroundColor: '#f5f5f5',
  borderRadius: '9999px',
  color: '#000',
  fontSize: '14px',
  fontWeight: 600,
  padding: '8px 16px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#ebebeb',
  },
};
